import React, { useRef, useCallback } from "react";
import { List } from "../../Components/common/List/List";
import { ListProvider } from "../../Components/common/List/Providers/List";
import { useAppContext } from "../../AppProvider";
import { useListProps } from "./utilities/list";
import { useTypes } from "../../utilities/types";
import { useIndexEmailNotificationEventsContext } from "./providers/Index";
import { getBadge } from "../../Components/Badges/utilities";
import { EmailNotificationEvent } from "../../Models/EmailNotificationEvent";
import moment from "moment";

const AnyListProvider = ListProvider as any;
const AnyList = List as any;

export const EmailNotificationEvents: React.FC = () => {
  const listRef = useRef<{ refresh: () => void } | null>(null);
  const listProps = useListProps();
  const { parentId } = useIndexEmailNotificationEventsContext();

  const renderHeader = () => {
    const { dictionary } = useAppContext();

    return (
      <div className="list-item px-2 border my-1">
        <div
          className="d-grid grid-column align-items-center"
          style={{
            gridTemplateColumns: "0.5fr 1fr 3fr",
          }}
        >
          <label className="label-2">{dictionary.words.status}</label>
          <label className="label-2">{dictionary.dates.date}</label>
          <label className="label-2">{dictionary.messages.message_sm}</label>
        </div>
      </div>
    );
  };

  const renderItem = useCallback((item: EmailNotificationEvent) => {
    return <ListItem item={item} />;
  }, []);

  return (
    <>
      <AnyListProvider
        path={listProps.path}
        parentId={parentId}
        defaultPagination={listProps.defaultPagination}
        sorting={listProps.sorting}
      >
        <AnyList
          ref={listRef}
          title={listProps.title}
          banner={listProps.banner}
          renderHeader={renderHeader}
          renderItem={renderItem}
          pagination={listProps.pagination}
          actionBar={listProps.actionBar}
          selectRowsEnabled={listProps.selectRowsEnabled}
        />
      </AnyListProvider>
    </>
  );
};

export default EmailNotificationEvents;

const ListItem: React.FC<{ item: EmailNotificationEvent }> = React.memo(
  ({ item }) => {
    const { emailEvents } = useTypes();

    const event = emailEvents.find((e) => e.value === item.eventType);

    return (
      <div className="list-item px-2 border my-1">
        <div
          className="d-grid grid-column align-items-center"
          style={{
            gridTemplateColumns: "0.5fr 1fr 3fr",
          }}
        >
          <div>{getBadge({ bgColor: null, text: event?.label })}</div>
          <div>
            <label className="label-3">
              {item.eventDate
                ? moment(item.eventDate).format("DD/MM/YYYY HH:mm:ss")
                : "-"}
            </label>
          </div>
          <div>
            <label className="label-3">{item.message || "-"}</label>
          </div>
        </div>
      </div>
    );
  }
);
